import filter from '@/js/util/symbols/filter'

export default {
  inject: { filter },
  props: {
    mode: {
      type: String,
      default: 'filtered',
    },
  },
  computed: {
    checkedLength() {
      return this.filter.checked.length - 1
    },
    filteredLength() {
      return this.filter.filtered.length - 1
    },

    determineUsage() {
      return this.filter.amountShown < this[`${this.mode}Length`]
    },
  },
  render(createElement) {
    const { determineUsage } = this
    const elementData = {
      on: {
        click: () => this.filter.$emit('set:filtered'),
      },
      directives: [{
        name: 'show',
        value: determineUsage,
      }],
    }
    return createElement('button', elementData, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseFilterLoadMoreButton.js